var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriggeredIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7586_10308)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.7382C14.6804 19.7405 13.8685 19.5802 13.1114 19.2665C12.3542 18.9529 11.6667 18.4923 11.0888 17.9112C10.5077 17.3332 10.047 16.6458 9.7334 15.8886C9.41979 15.1314 9.25948 14.3195 9.26174 13.5C9.2594 12.6804 9.41968 11.8685 9.73329 11.1113C10.0469 10.3541 10.5076 9.66667 11.0888 9.08877C11.6667 8.5077 12.3542 8.04703 13.1114 7.73342C13.8686 7.41981 14.6804 7.25949 15.5 7.26175C16.3197 7.2593 17.1317 7.41952 17.8891 7.73314C18.6464 8.04676 19.334 8.50753 19.912 9.08877C20.4931 9.66662 20.9539 10.354 21.2675 11.1112C21.5812 11.8683 21.7415 12.6802 21.7393 13.4997C21.7415 14.3193 21.5812 15.1312 21.2675 15.8885C20.9539 16.6457 20.4931 17.3332 19.912 17.9112C19.334 18.4924 18.6464 18.9532 17.8891 19.2668C17.1317 19.5804 16.3197 19.7406 15.5 19.7382ZM15.5 7.79188C12.3523 7.79188 9.79161 10.3526 9.79161 13.5C9.79161 16.6474 12.3523 19.2083 15.5 19.2083C18.6477 19.2083 21.2083 16.6469 21.2083 13.5C21.2083 10.3531 18.6474 7.79188 15.5 7.79188Z",
    fill: "#FF4F17",
    stroke: "#FF4F17",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2654 13.7604C22.1185 13.7604 20.3692 13.7644 20.2225 13.7604C20.0511 13.7548 19.9448 13.6512 19.9453 13.5003C19.9458 13.3494 20.054 13.2436 20.2239 13.2415C20.5219 13.2375 22.4227 13.2369 22.7207 13.2415C22.8868 13.2434 22.9987 13.3542 22.9985 13.503C22.9982 13.6517 22.8884 13.7575 22.7191 13.7625C22.5679 13.7674 22.4165 13.7625 22.2651 13.7625L22.2654 13.7604Z",
    fill: "#FF4F17",
    stroke: "#FF4F17",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.32 13.7604C10.1732 13.7604 8.42384 13.7644 8.27722 13.7604C8.10576 13.7548 7.99947 13.6512 8 13.5003C8.00054 13.3494 8.1087 13.2436 8.27856 13.2415C8.57661 13.2375 10.4773 13.2369 10.7754 13.2415C10.9415 13.2434 11.0534 13.3542 11.0531 13.503C11.0529 13.6517 10.9431 13.7575 10.7738 13.7625C10.6226 13.7674 10.4712 13.7625 10.3198 13.7625L10.32 13.7604Z",
    fill: "#FF4F17",
    stroke: "#FF4F17",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2385 20.2651C15.2385 20.1185 15.2345 18.3689 15.2385 18.2223C15.2441 18.0508 15.3478 17.9448 15.4987 17.9453C15.6496 17.9458 15.7553 18.054 15.7574 18.2239C15.7615 18.5219 15.762 20.4224 15.7574 20.7204C15.7556 20.8868 15.6447 20.9987 15.496 20.9985C15.3472 20.9982 15.2415 20.8884 15.2364 20.7188C15.2319 20.5679 15.2364 20.4165 15.2364 20.2648L15.2385 20.2651Z",
    fill: "#FF4F17",
    stroke: "#FF4F17",
    strokeWidth: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2416 8.31977C15.2416 8.17315 15.2376 6.42358 15.2416 6.27695C15.2472 6.10549 15.3509 5.99947 15.5018 6C15.6527 6.00054 15.7584 6.1087 15.7606 6.27856C15.7646 6.57661 15.7651 8.47708 15.7606 8.77513C15.7587 8.94151 15.6478 9.05342 15.4991 9.05315C15.3503 9.05288 15.2464 8.94312 15.2403 8.77353C15.2358 8.62263 15.2403 8.4712 15.2403 8.31951L15.2416 8.31977Z",
    fill: "#FF4F17",
    stroke: "#FF4F17",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 14.7042C17.9998 13.2532 17.9998 11.8024 17.9998 10.3517C17.9998 10.1019 17.9115 10.0028 17.6914 10.001C17.3988 9.99872 17.1062 10.001 16.8138 10.001C16.5614 10.001 16.4761 10.0927 16.483 10.3813C16.4861 10.4967 16.4576 10.5446 16.3558 10.578C15.3246 10.9179 14.2947 11.2629 13.266 11.6132C13.0348 11.6916 13.0002 11.7556 13.0004 12.0258C13.0004 12.6342 13.0004 13.2429 13.0017 13.8513C13.0017 13.9689 12.9902 14.1108 13.0271 14.2238C13.0752 14.3694 13.2482 14.3833 13.3648 14.4225L13.6238 14.509C13.8485 14.5834 14.0497 14.6488 14.2495 14.7183C14.2537 14.7199 14.2576 14.7223 14.2612 14.7252L14.8571 14.9271C14.9123 14.9432 14.9403 14.9504 14.9678 14.9597C15.4222 15.1119 15.8757 15.2673 16.3314 15.4141C16.439 15.449 16.4901 15.4931 16.484 15.6361C16.4713 15.8985 16.57 15.9994 16.8046 16C17.0971 16 17.3895 16 17.682 16C17.9094 16 17.9977 15.8997 17.9993 15.6433C18.0005 15.3287 17.9998 15.0165 17.9998 14.7042ZM16.4731 14.8786C16.0354 14.7327 15.6095 14.5903 15.1841 14.4484C14.6609 14.2731 14.1383 14.0943 13.6144 13.9219C13.5342 13.8957 13.4968 13.8642 13.4981 13.7593C13.5037 13.2501 13.5024 12.7406 13.4981 12.2311C13.4981 12.1446 13.5215 12.1051 13.5938 12.0808C14.5396 11.766 15.4842 11.4496 16.4275 11.1316C16.4424 11.1296 16.4575 11.1296 16.4723 11.1316L16.4731 14.8786ZM17.4952 15.4265H16.9797V10.5639H17.4952V15.4265Z",
    fill: "#FF4F17",
    stroke: "#FF4F17",
    strokeWidth: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3514 12.9523C12.3514 13.2728 12.3514 13.5919 12.3514 13.9119C12.3514 14.1052 12.2544 14.2145 12.0923 14.2129C11.9302 14.2113 11.8359 14.1018 11.8359 13.9081C11.8359 13.2595 11.8359 12.611 11.8359 11.9625C11.8359 11.8114 11.9083 11.7158 12.037 11.6875C12.1607 11.6607 12.26 11.7029 12.3167 11.8135C12.3412 11.87 12.3526 11.9314 12.35 11.993C12.3533 12.3127 12.3514 12.6326 12.3514 12.9523Z",
    fill: "#FF4F17",
    stroke: "#FF4F17",
    strokeWidth: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.535 17H13.4631C13.3403 17 13.2225 16.957 13.1356 16.8805C13.0488 16.804 13 16.7002 13 16.592V14L15 14.467V16.5915C15.0001 16.6452 14.9881 16.6985 14.9647 16.7481C14.9414 16.7978 14.9071 16.8429 14.8639 16.8809C14.8207 16.9189 14.7694 16.9489 14.713 16.9694C14.6565 16.9898 14.5961 17.0002 14.535 17ZM13.6119 16.4601H14.3865V14.8826L13.6119 14.7017V16.4601Z",
    fill: "#FF4F17",
    stroke: "#FF4F17",
    strokeWidth: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.418 11.918V13.9744C18.8309 13.9744 19.1658 13.5142 19.1658 12.9465C19.1658 12.3787 18.8309 11.918 18.418 11.918Z",
    fill: "#FF4F17"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7586_10308",
    x: 0,
    y: 0,
    width: 31,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.772549 0 0 0 0 0.839216 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7586_10308"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7586_10308",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggeredIcon);
export default __webpack_public_path__ + "static/media/Triggered_icon.31cda1f16cb029a2cae144ff91b19971.svg";
export { ForwardRef as ReactComponent };